import React, { useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import { setAndValidateData } from '@/redux/ducks/receipt/edit'
import { useDispatch, useSelector } from 'react-redux'
import { setFormValidationForGWG } from '@/redux/ducks/banking/bookingAssignments'
import { CHART_OF_ACCOUNT_SKR_TYPE } from '@/modules/settings/components/tax-settings/chart-of-accounts/constants'

interface Position {
  totalGross: number;
  totalNet: number;
  vatPercent: number;
  vat: number;
  bookkeepingAccountId: string;
  accountVatOption: number;
  bookkeepingAccountDescriptionCustom: string;
  bookkeepingAccountNo: number;
  accountCategory: string;
  priceNet: number;
}

interface GWGHelperProps {
  positions: Position[];
  isBanking: boolean;
}

const useStyles = makeStyles((theme) => ({
  gwgHelperContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e8efff',
    padding: 16,
    borderRadius: 8,
    margin: '16px 0',
    gap: 10,
  },
  gwgHelperContent: {
    '& h1': {
      fontSize: theme.fontSizes.small,
      margin: '0 0 8px',
    },
    '& p': {
      margin: 0,
      fontSize: theme.fontSizes.smaller,
    },
  },
  notesInfo: {
    width: 70,
    height: 26,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.blue,
    borderRadius: 12,
  },
  notesInfoWrapper: {
    fontSize: theme.fontSizes.medium,
    color: theme.white,
  },
}))

const GWGHelper: React.FC<GWGHelperProps> = ({ positions, isBanking }) => {
  const currentSkrType = useSelector(state => state.tenant.settings.currentSkrType)
  const dispatch = useDispatch()
  const classes = useStyles()

  const gwgPosition = positions?.find(
    (pos) =>
      ((pos.bookkeepingAccountNo === 480 && currentSkrType === CHART_OF_ACCOUNT_SKR_TYPE.skr03) || (pos.bookkeepingAccountNo === 670 && CHART_OF_ACCOUNT_SKR_TYPE.skr04))
      && pos.bookkeepingAccountId != null,
  )

  useEffect(() => {
    if (gwgPosition) {
      const totalNet = gwgPosition.totalNet
      if (totalNet < 250.01) {
        isBanking
          ? dispatch(setFormValidationForGWG(false))
          : dispatch(setAndValidateData({ data: { positions: gwgPosition } }))
      } else if (totalNet > 1000.00) {
        isBanking
          ? dispatch(setFormValidationForGWG(false))
          : dispatch(setAndValidateData({ data: { positions: gwgPosition } }))
      }
    } else {
      isBanking
        ? dispatch(setFormValidationForGWG(true))
        : dispatch(setAndValidateData({ data: { positions: gwgPosition } }))
    }
  }, [gwgPosition])

  if (!gwgPosition) {
    return null
  }

  const renderHelperContent = (title: string, message: string) => (
    <div className={classes.gwgHelperContainer}>
      <div className={classes.notesInfo}>
        <div className={classes.notesInfoWrapper}>!</div>
      </div>
      <div className={classes.gwgHelperContent}>
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
    </div>
  )

  const totalNet = gwgPosition.totalNet

  if (totalNet < 250.01 && totalNet > 0) {
    return renderHelperContent(
      lang.economicAsset.gwg.infoTitle1,
      lang.economicAsset.gwg.infoDescription1,
    )
  } else if (totalNet >= 800.01 && totalNet <= 1000.00) {
    return renderHelperContent(
      lang.economicAsset.gwg.infoTitle2,
      lang.economicAsset.gwg.infoDescription2,
    )
  } else if (totalNet >= 1000.01) {
    return renderHelperContent(
      lang.economicAsset.gwg.infoTitle3,
      lang.economicAsset.gwg.infoDescription3,
    )
  }
  return null
}

export default GWGHelper
